import React from 'react';
import { useRouter } from 'next/router';

import { parseBanner } from 'helpers/ProductsListingHelpers';
import { useAnalytics } from 'hooks/useAnalytics';
import { ProductsListing } from 'templates/common';

import type { ICategoryPageUrlParams, ICategoryProductsListing, IListingBanner } from 'types';

import styles from './SubCategoryTemplate.module.scss';

interface Props {
  category: ICategoryProductsListing['payload'],
  urlParams: ICategoryPageUrlParams
}

const SubCategoryTemplate = React.memo((props: Props) => {

  const {
    category,
    urlParams,
  } = props;

  // Props

  const {
    //
    analyticsListId,
    analyticsListName,
    //
    name,
    //
    items: products = [],
    banners = [],
    //
    pages: totalPages,
    page: activePage,
    total: count
    //
  } = category;

  // Hooks

  const router = useRouter();
  const analytics = useAnalytics();

  // Effects

  React.useEffect(() => {
    if (router?.query?.searchQuery) {
      analytics.searchAutosuggest({
        term: router.query.searchQuery as string,
        results: count,
        category: name
      });
    }
  }, [router?.query]);

  // Props

  const parsedBanners: IListingBanner[] = React.useMemo(() => {
    return banners?.map(parseBanner).filter((banner): banner is IListingBanner => !!banner);
  }, [banners]);

  // Render

  return (
    <ProductsListing
      className={styles.root}
      //
      title={name}
      urlParams={urlParams}
      //
      products={products}
      banners={parsedBanners}
      //
      productCardProps={{
        bypassQuantityVariants: true
      }}
      productListProps={{
        analyticsListId,
        analyticsListName
      }}
      //
      count={count}
      totalPages={totalPages}
      activePage={activePage}
      dataTestId="category-products-list"
      //
      wide={false}
    />
  );
});

export default SubCategoryTemplate;
